/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import React, { useState } from 'react';

import { useTranslation } from '~/app';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '~/components/Dialog';
import { Button, Checkbox } from '~/components/Form';

interface Props {
  open: boolean;
  onClose: (dontAskAgain: boolean) => void;
  onAccept: (dontAskAgain: boolean) => void;
}

const FullscreenDialog = ({ open, onClose, onAccept }: Props): JSX.Element => {
  const { t } = useTranslation();
  const [isDontAskAgainSelected, setIsDontAskAgainSelected] = useState(false);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose(isDontAskAgainSelected)}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle>{t('settings_fullscreenDialogTitle')}</DialogTitle>
        <DialogDescription className="text-slate-500">
          {t('settings_fullscreenDialogContent')}
        </DialogDescription>

        <div className="mb-6">
          <Checkbox
            id="dontAskAgain"
            checked={isDontAskAgainSelected}
            onCheckedChange={setIsDontAskAgainSelected}
            label={t('settings_fullscreenDialogDisable')}
          />
        </div>

        <div className="flex justify-end space-x-2">
          <Button variant="secondary" onClick={() => onClose(isDontAskAgainSelected)}>
            {t('settings_fullscreenDialogCancel')}
          </Button>
          <Button onClick={() => onAccept(isDontAskAgainSelected)}>
            {t('settings_fullscreenDialogAccept')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FullscreenDialog;
